import { Facebook, Youtube } from 'lucide-react';
import { CONTACTS } from '../config/brand';

const XIcon = ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
);

const TikTokIcon = ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.04-.1z" />
    </svg>
);

export const SocialLinks = ({ className = '' }) => (
    <div className={`flex items-center justify-center gap-3 ${className}`} data-testid="social-links">
        <a href={CONTACTS.socials.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"
           className="w-10 h-10 rounded-full flex items-center justify-center border transition-colors"
           style={{ borderColor: 'var(--border-subtle)', color: 'var(--text-secondary)' }}
           onMouseEnter={(e) => { e.currentTarget.style.color = '#FFB800'; e.currentTarget.style.borderColor = '#FFB800'; }}
           onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--text-secondary)'; e.currentTarget.style.borderColor = 'var(--border-subtle)'; }}
           data-testid="social-facebook">
            <Facebook className="w-4 h-4" />
        </a>
        <a href={CONTACTS.socials.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube"
           className="w-10 h-10 rounded-full flex items-center justify-center border transition-colors"
           style={{ borderColor: 'var(--border-subtle)', color: 'var(--text-secondary)' }}
           onMouseEnter={(e) => { e.currentTarget.style.color = '#FFB800'; e.currentTarget.style.borderColor = '#FFB800'; }}
           onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--text-secondary)'; e.currentTarget.style.borderColor = 'var(--border-subtle)'; }}
           data-testid="social-youtube">
            <Youtube className="w-4 h-4" />
        </a>
        <a href={CONTACTS.socials.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok"
           className="w-10 h-10 rounded-full flex items-center justify-center border transition-colors"
           style={{ borderColor: 'var(--border-subtle)', color: 'var(--text-secondary)' }}
           onMouseEnter={(e) => { e.currentTarget.style.color = '#FFB800'; e.currentTarget.style.borderColor = '#FFB800'; }}
           onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--text-secondary)'; e.currentTarget.style.borderColor = 'var(--border-subtle)'; }}
           data-testid="social-tiktok">
            <TikTokIcon className="w-4 h-4" />
        </a>
        <a href={CONTACTS.socials.x} target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)"
           className="w-10 h-10 rounded-full flex items-center justify-center border transition-colors"
           style={{ borderColor: 'var(--border-subtle)', color: 'var(--text-secondary)' }}
           onMouseEnter={(e) => { e.currentTarget.style.color = '#FFB800'; e.currentTarget.style.borderColor = '#FFB800'; }}
           onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--text-secondary)'; e.currentTarget.style.borderColor = 'var(--border-subtle)'; }}
           data-testid="social-x">
            <XIcon className="w-4 h-4" />
        </a>
    </div>
);
